export default {
  manage_vehicleStatus: "Vehicle Status",
  manage_vehicleStatus_statusLabel: "Status Label",
  manage_vehicleStatus_vehicleStatusIcon: "Icon",
  manage_vehicleStatus_deleted: "Status Label was deleted successfully",
  manage_vehicleStatusList_deleted: "Status Labels was deleted successfully",
  manage_vehicleStatus_search_by_status_label: "Search by Status Label"
};
